import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}

import { reactive, onMounted, computed } from "vue";
import type { PropType } from "vue";
import { useStore } from "vuex";
import { Application, Applicant } from "@/models/application";
import Tile from "@/components/shared/Tile.vue";
import ApplicationChecklistItem from "@/components/ApplicationChecklistItem.vue";
import useChecklistHelpers from "@/use/checklistHelpers";
import Income from "@/components/checklist/Income.vue";
import ChecklistItemWrapper from "@/components/checklist/ChecklistItemWrapper.vue";
import { StipulationStatusIds } from "@/config/constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationChecklistIncome',
  props: {
  applicant: Object as PropType<Applicant>,
  application: Object as PropType<Application>,
},
  emits: ["hydrateStore"],
  setup(__props, { emit: __emit }) {

const { updateStipulationStatus, replaceObjectWithId } = useChecklistHelpers();

const props = __props;

const emit = __emit;
const store = useStore();

const showCompletedItems = computed<boolean>(
  () =>
    sortedItemsState.value?.filter(
      (item: any) => item.complete === true && item.formattedTitle === "Income Verification",
    )?.length > 0,
);
const applicationId = computed(() => store.state.appData.application.id);

const selectedIncomeSourcesCount = computed(() => store.getters["SelectedIncomeSourcesCount"]);
const sortedItemsState = computed(() => store.state.checklistModule.sortedItems);
const incomeStipsExist = computed(() => {
  if (sortedItemsState?.value && sortedItemsState?.value?.length > 0) {
    let stips = sortedItemsState?.value?.find((s: any) => s.title === "Income Verification")?.items;
    return stips?.length > 0;
  } else {
    return undefined;
  }
});

let sortedItems = reactive([] as any[]);

async function getApplicationStips() {
  await store.dispatch("checklistModule/getSortedChecklistItems");
}

async function handleUploadSuccess(event: any) {
  const status =
    store.state.lookupsModule?.lookups?.stipStatuses?.length > 0
      ? store.state.lookupsModule?.lookups?.stipStatuses.find(
          (s: any) => s.id === StipulationStatusIds.PENDING
        )
      : false;
  if (applicationId.value) {
    const response = await updateStipulationStatus(applicationId.value, status, event);
    replaceObjectWithId(sortedItems, response.id, response);
  }
}

onMounted(async () => {
  await getApplicationStips();
  sortedItems = store.getters["checklistModule/sortedItems"];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tile, null, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "title" }, "To-Do List", -1)),
      _withDirectives(_createVNode(ChecklistItemWrapper, {
        title: 'Income Verification',
        complete: false
      }, {
        default: _withCtx(() => [
          _createVNode(Income, {
            applicant: __props.applicant,
            application: __props.application,
            onIncomeSourcesUpdated: getApplicationStips
          }, null, 8, ["applicant", "application"])
        ]),
        _: 1
      }, 512), [
        [_vShow, !incomeStipsExist.value]
      ]),
      (incomeStipsExist.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedItemsState.value.filter((item) => item.complete !== true && item.formattedTitle === 'Income Verification'), (item, index) => {
              return (_openBlock(), _createBlock(ApplicationChecklistItem, {
                key: index,
                item: item,
                onHandleUploadSuccess: _cache[0] || (_cache[0] = ($event: any) => (handleUploadSuccess($event))),
                onIncomeSourcesUpdated: getApplicationStips
              }, null, 8, ["item"]))
            }), 128)),
            (showCompletedItems.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Completed Items"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedItemsState.value.filter((item) => item.complete === true && item.formattedTitle === 'Income Verification'), (item, index) => {
              return (_openBlock(), _createBlock(ApplicationChecklistItem, {
                key: index,
                item: item
              }, null, 8, ["item"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})